import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, of, switchMap } from 'rxjs';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { Location } from '@angular/common';

@Injectable()
export class AdminGuard extends MsalGuard {
  constructor(
    @Inject(MSAL_GUARD_CONFIG) msalGuardConfig: MsalGuardConfiguration,
    msalBroadcastService: MsalBroadcastService,
    private authmsalService: MsalService,
    location: Location,
    private adrouter: Router,
    private userService: AuthService
  ) {
    super(msalGuardConfig, msalBroadcastService, authmsalService, location, adrouter);
  }

  override canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return super.canActivate(route, state).pipe(
      switchMap(isAuthenticated => {
        if (isAuthenticated == true) {
          const accountInfo = this.authmsalService.instance.getActiveAccount();
          if (accountInfo != null) {
            this.userService.setAuthDetais(accountInfo);
            if (this.userService.$msaltoken()?.token && this.userService.$fabricToken()?.token) {
              if (this.userService.$userInfo() != null) {
                return of(true);
              } else {
                return this.userService.getmsalTokensWithDiffScopes().pipe(
                  switchMap(res => {
                    if (res != null) {
                      this.userService.$userInfo.set(res);
                      return of(res.isAdmin);
                    } else {
                      return of(false);
                    }
                  })
                );
              }
            }
            return this.userService.getmsalTokensWithDiffScopes().pipe(
              switchMap((res) => {
                if (res != null) {
                  this.userService.$userInfo.set(res);
                  return of(res.isAdmin);
                } else {
                  return of(false);
                }
              })
            );
          }
          return of(false);
        } else {
          return of(isAuthenticated);
        }
      })
    );
  }
}
